module.exports = __webpack_public_path__ + "static/media/vf_mwallet_core.a31a63fd.svg";